import React from "react";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CreatePurchaseInvoiceForm from "../../../components/forms/inventory/createPurchaseInvoiceForm";



const CreatePurchaseInvoice = () => {
  
  const items = [
    { label: "Purchase Order", path: "/inventory/purchase-order" },
    { label: "Create Invoice", path: "" },
  ];

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        breadcrumbs={items}
        isSearch={false}
        isFilter={false}
        buttons={false}
      />

      <div>
        <CreatePurchaseInvoiceForm />
      </div>
    </div>
  );
};

export default CreatePurchaseInvoice;
